
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1316Dialog extends Serenity.EntityDialog<Report_1316Row, any> {
        protected getFormKey() { return Report_1316Form.formKey; }
        protected getIdProperty() { return Report_1316Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1316Row.localTextPrefix; }
        protected getNameProperty() { return Report_1316Row.nameProperty; }
        protected getService() { return Report_1316Service.baseUrl; }
        protected getDeletePermission() { return Report_1316Row.deletePermission; }
        protected getInsertPermission() { return Report_1316Row.insertPermission; }
        protected getUpdatePermission() { return Report_1316Row.updatePermission; }

        protected form = new Report_1316Form(this.idPrefix);

    }
}